import { defineStore } from 'pinia'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import RealestateAPI from '@/modules/realestate/constants/realestate.api.uri.const.ts'
import { mappingValuesToForm, formatDataToSubmit } from '@/modules/realestate/helper/listing'
import { PROCESSING_STATUS } from '@/modules/realestate/constants/realestate.const'

export enum AssetDetailActionType {
  FETCHING = 'fetching',
  FETCHED = 'fetched',
  FETCH_FAILED = 'fetch_failed',
}

interface ListingDetailState {
  assets: {
    [key: string]: {
      action_type: AssetDetailActionType
      action_message: string
      data: any
      formData: any
    }
  }
  attributes?: {
    action_type: AssetDetailActionType
    data: any
  }
}

export const useAssetDetailStore = defineStore('assets.detail', {
  state: (): ListingDetailState => ({
    assets: {},
  }),
  getters: {},
  actions: {
    async fetchAssetDetail(id: number) {
      return new Promise(async (resolve, reject) => {
        try {
          // fetching
          this.assets[id] = {
            ...this.assets[id],
            action_type: AssetDetailActionType.FETCHING,
          }
          const res = await APIClient.get(RealestateAPI.asset.detail.replace(':id', id.toString()))
          this.assets[id] = {
            action_type: AssetDetailActionType.FETCHED,
            action_message: res?.data?.message || '',
            data: res.data.data,
            formData: {},
          }
          resolve(this.assets[id].data)
        } catch (e) {
          this.assets[id].action_type = AssetDetailActionType.FETCH_FAILED
          this.assets[id].action_message = e.message || 'Failed to fetch listing detail'
          reject(e)
        }
      })
    },
    async setListingDetail(id: number, account: Object) {
      this.assets[id] = {
        action_type: AssetDetailActionType.FETCHED,
        action_message: '',
        account: { ...this.assets[id].account, ...account },
      }
    },
  },
})
